export default __webpack_public_path__ + "static/media/3pool.f376372b.svg";